import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;
  const isServicesActive = () => {
    const servicePaths = [
      '/canalizacao',
      '/remodelacao-casa-de-banho',
      '/pintura',
      '/instalacao-piso-flutuante',
      '/reparacao-eletrica',
      '/servicos'
    ];
    return servicePaths.includes(location.pathname);
  };

  const serviceLinks = [
    { path: '/canalizacao', label: 'Canalização' },
    { path: '/remodelacao-casa-de-banho', label: 'Remodelação de Casa de Banho' },
    { path: '/pintura', label: 'Pintura Interior e Exterior' },
    { path: '/instalacao-piso-flutuante', label: 'Instalação de Piso Flutuante' },
    { path: '/reparacao-eletrica', label: 'Reparação Elétrica' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-sm z-50 transition-all duration-300">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 cursor-pointer group">
            <img
              src="/images/logo/logo.jpeg"
              alt="Remodelando PT Logo"
              className="h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-105 mix-blend-multiply"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-10">
            <Link
              to="/"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/') ? 'text-remodelando-green' : 'text-gray-800 hover:text-remodelando-green'
                }`}
            >
              Home
            </Link>

            {/* Dropdown de Serviços */}
            <div className="relative group">
              <button
                className={`flex items-center gap-1 text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isServicesActive() ? 'text-remodelando-green' : 'text-gray-800 hover:text-remodelando-green'
                  }`}
              >
                Serviços <i className="ri-arrow-down-s-line transition-transform group-hover:rotate-180"></i>
              </button>

              <div className="absolute top-full left-0 w-72 bg-white shadow-xl rounded-sm py-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-4 group-hover:translate-y-0 border-t-4 border-remodelando-green">
                <Link
                  to="/servicos"
                  className="block px-6 py-3 text-sm text-gray-800 hover:bg-gray-50 hover:text-remodelando-green font-bold border-b border-gray-100 transition-colors"
                >
                  VER TODOS OS SERVIÇOS
                </Link>
                {serviceLinks.map((service) => (
                  <Link
                    key={service.path}
                    to={service.path}
                    className={`block px-6 py-3 text-sm hover:bg-gray-50 hover:text-remodelando-green transition-colors font-medium border-b border-gray-50 last:border-0 ${isActive(service.path) ? 'text-remodelando-green bg-gray-50' : 'text-gray-600'
                      }`}
                  >
                    {service.label}
                  </Link>
                ))}
              </div>
            </div>

            <Link
              to="/sobre"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/sobre') ? 'text-remodelando-green' : 'text-gray-800 hover:text-remodelando-green'
                }`}
            >
              Sobre nós
            </Link>
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="tel:+351927521640"
              onClick={() => {
                if (typeof (window as any).gtag_report_conversion === 'function') {
                  (window as any).gtag_report_conversion();
                }
              }}


              className="px-6 py-2 bg-[#1B5E20] text-white rounded-lg font-bold text-sm tracking-wide hover:bg-[#0D3B10] transition-all cursor-pointer whitespace-nowrap shadow-md hover:shadow-lg hover:-translate-y-0.5 flex items-center gap-2"
            >
              <i className="ri-phone-fill text-lg"></i>
              Ligar: 927 521 640
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-md border-t border-gray-100 max-h-[calc(100vh-64px)] overflow-y-auto">
          <nav className="container mx-auto px-6 py-6 flex flex-col gap-2">
            <Link to="/" className="py-3 px-4 text-gray-800 hover:text-remodelando-green cursor-pointer hover:bg-gray-50 rounded-sm font-bold uppercase tracking-widest text-xs" onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>

            {/* Mobile Services Accordion */}
            <div className="py-2">
              <button
                onClick={() => setIsServicesOpen(!isServicesOpen)}
                className="flex items-center justify-between w-full py-3 px-4 text-gray-800 hover:text-remodelando-green cursor-pointer font-bold uppercase tracking-widest text-xs"
              >
                <span>Serviços</span>
                <i className={`ri-arrow-down-s-line transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isServicesOpen && (
                <div className="pl-6 mt-2 flex flex-col gap-1 border-l-2 border-remodelando-green ml-4">
                  <Link
                    to="/servicos"
                    className="py-3 px-4 text-xs text-remodelando-green font-bold uppercase tracking-wide hover:bg-gray-50 rounded-sm"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Ver Todos
                  </Link>
                  {serviceLinks.map((service) => (
                    <Link
                      key={service.path}
                      to={service.path}
                      className="py-3 px-4 text-xs text-gray-600 hover:text-remodelando-green hover:bg-gray-50 rounded-sm uppercase tracking-wide"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {service.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link to="/sobre" className="py-3 px-4 text-gray-800 hover:text-remodelando-green cursor-pointer hover:bg-gray-50 rounded-sm font-bold uppercase tracking-widest text-xs" onClick={() => setIsMenuOpen(false)}>
              Sobre nós
            </Link>
            <a
              href="https://wa.me/351927521640?text=Olá,%20gostaria%20de%20solicitar%20um%20orçamento"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                if (typeof window !== 'undefined' && (window as any).gtag) {
                  (window as any).gtag('event', 'conversion', {
                    'send_to': 'AW-16904278163/CONVERSION_LABEL',
                  });
                }
              }}
              className="mt-6 px-5 py-4 bg-[#25D366] text-white rounded-lg font-bold text-sm tracking-wide text-center cursor-pointer shadow-md flex justify-center items-center gap-2"
            >
              <i className="ri-whatsapp-fill text-xl"></i>
              Falar no WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}